const previewProfile = {
  user_guid: "preview-user-guid",
  member_id: "CLARINS-0001",
  member_level_id: 1,
  member_list: [
    {
      id: 1,
      is_default: 1,
      display_name: "Gold",
      member_level_language: [{ display: "Gold" }],
      upgrade_tier_id: 0,
      upgrade_baht: 50000,
      maintain_baht: 30000
    }
  ],
  display: "Gold",
  first_name_th: "Preview",
  last_name_th: "Member",
  first_name_en: "Preview",
  last_name_en: "Member",
  id_card: "51364863335",
  birthday: "1998-01-01",
  birthday_day: "01",
  birthday_month: "01",
  birthday_year: "1998",
  telephone: "0812345678",
  email: "preview@example.com",
  total_point: 12500,
  total_coupon_can_use: 3,
  total_random_reward: 2,
  current_accumulated_amount: 18000,
  balance_to_upgrade: 12000,
  point_expired: 250,
  point_expired_date: "2026-12-31",
  picture: "",
  login_type: 1
};

const previewLabels = [
  { id: 1, name: "th", image_url: "", sort_order: 1 },
  { id: 2, name: "en", image_url: "", sort_order: 2 }
];

const previewLabelValues = [
  { label_id: 1, label_name: "news", name: "News" },
  { label_id: 2, label_name: "all", name: "All" },
  { label_id: 3, label_name: "collect_point", name: "Collect Point" },
  { label_id: 4, label_name: "point_expired", name: "Point Expired" },
  { label_id: 5, label_name: "currency_unit", name: "Points" },
  { label_id: 6, label_name: "earn_channel", name: "Earn Channel" },
  { label_id: 7, label_name: "add", name: "Add" },
  { label_id: 8, label_name: "profile", name: "Profile" },
  { label_id: 9, label_name: "privilege", name: "Privilege" },
  { label_id: 10, label_name: "setting", name: "Setting" },
  { label_id: 11, label_name: "logout", name: "Logout" },
  { label_id: 12, label_name: "confirm_logout", name: "Confirm logout?" },
  { label_id: 13, label_name: "complate_profile", name: "Profile Complete" },
  { label_id: 14, label_name: "minimal_profile_tab_title", name: "MY ACCOUNT" },
  { label_id: 15, label_name: "loading", name: "Loading" },
  { label_id: 16, label_name: "home", name: "Home" },
  { label_id: 17, label_name: "redeem_text", name: "Gifts" },
  {
    label_id: 18,
    label_name: "transaction_header",
    name: "Transaction history"
  },
  { label_id: 19, label_name: "your_receipt", name: "Your receipt" },
  { label_id: 20, label_name: "profile_coupon", name: "My coupons" },
  { label_id: 21, label_name: "reward_list", name: "Gifts" },
  {
    label_id: 22,
    label_name: "marketplace_channel",
    name: "Connection channel"
  },
  {
    label_id: 23,
    label_name: "btn_connect_market",
    name: "Add connection channel"
  },
  {
    label_id: 24,
    label_name: "btn_connect_success_market",
    name: "Connected"
  },
  { label_id: 25, label_name: "send_receipt", name: "Submit receipt" },
  { label_id: 26, label_name: "retry", name: "Retry" },
  {
    label_id: 27,
    label_name: "error_message",
    name: "An error occurred"
  },
  {
    label_id: 28,
    label_name: "note_market_1",
    name: "Connect a channel after confirming receipt of the product"
  },
  {
    label_id: 29,
    label_name: "note_market_2",
    name: "Future orders will be added automatically"
  },
  { label_id: 30, label_name: "market_name", name: "Store" },
  { label_id: 31, label_name: "order_no", name: "Order number" },
  { label_id: 32, label_name: "date", name: "Date" },
  { label_id: 33, label_name: "confirm", name: "Confirm" },
  { label_id: 34, label_name: "cancel", name: "Cancel" },
  { label_id: 35, label_name: "reward_back_home", name: "Back to home" },
  { label_id: 36, label_name: "purchase_channel", name: "Sales channel" },
  { label_id: 37, label_name: "status", name: "Status" },
  { label_id: 38, label_name: "success", name: "Success" },
  { label_id: 39, label_name: "close_window", name: "Close" },
  { label_id: 40, label_name: "back", name: "Back" },
  { label_id: 41, label_name: "no_data", name: "No data" },
  {
    label_id: 42,
    label_name: "transaction_empty",
    name: "No transactions"
  },
  { label_id: 43, label_name: "number_times", name: "Rights received" },
  { label_id: 44, label_name: "right_unit", name: "rights" },
  { label_id: 45, label_name: "invoice_no", name: "Invoice no." },
  { label_id: 46, label_name: "description", name: "Description" },
  { label_id: 47, label_name: "amount", name: "Amount" },
  { label_id: 48, label_name: "list", name: "items" },
  { label_id: 49, label_name: "currency_sign", name: "฿" },
  { label_id: 50, label_name: "see_detail", name: "View details" },
  { label_id: 51, label_name: "close", name: "Close" },
  { label_id: 52, label_name: "transaction_title", name: "Transaction" },
  { label_id: 53, label_name: "grand_total", name: "Total" },
  { label_id: 54, label_name: "history_use", name: "Receipt History" },
  {
    label_id: 55,
    label_name: "limit_user_receipt",
    name: "You have reached today's receipt limit"
  },
  { label_id: 56, label_name: "per_day", name: "per day" },
  {
    label_id: 57,
    label_name: "no_receipt_upload",
    name: "Add a receipt to continue"
  },
  { label_id: 58, label_name: "upload_image_text", name: "Add image" },
  { label_id: 59, label_name: "delete", name: "Delete" },
  { label_id: 60, label_name: "next", name: "Next" },
  {
    label_id: 61,
    label_name: "confirm_send_receipt",
    name: "Confirm receipt submission?"
  },
  {
    label_id: 62,
    label_name: "confirm_message_send_receipt",
    name: "Please check your receipt before submitting."
  },
  {
    label_id: 63,
    label_name: "receipt_campaign_date",
    name: "This campaign is available during"
  },
  {
    label_id: 64,
    label_name: "receipt_campaign_expired",
    name: "This campaign has expired"
  },
  {
    label_id: 65,
    label_name: "receipt_campaign_not_found",
    name: "Receipt campaign not found"
  },
  {
    label_id: 66,
    label_name: "receipt_max_error_message_1",
    name: "The invalid receipt limit has been reached"
  },
  {
    label_id: 67,
    label_name: "receipt_max_error_message_2",
    name: "Please try again tomorrow or contact support"
  },
  {
    label_id: 68,
    label_name: "receipt_max_upload_message",
    name: "Today's receipt limit has been reached"
  },
  {
    label_id: 69,
    label_name: "receipt_upload_success",
    name: "Receipt uploaded successfully"
  },
  { label_id: 70, label_name: "receipt_unit", name: "receipt(s)" },
  {
    label_id: 71,
    label_name: "upload_receipt_loading",
    name: "Your receipt is being reviewed. You can check its status later."
  },
  { label_id: 72, label_name: "go_to_history", name: "Go to history" },
  { label_id: 73, label_name: "total_spend", name: "Remaining points" },
  { label_id: 74, label_name: "send_check", name: "Submit for review" },
  {
    label_id: 75,
    label_name: "receipt_cancel_invoice",
    name: "Cancel this item"
  },
  { label_id: 76, label_name: "receipt_submitted_date", name: "Submitted" },
  {
    label_id: 77,
    label_name: "profile_general",
    name: "General information"
  },
  { label_id: 78, label_name: "firstname", name: "First name" },
  { label_id: 79, label_name: "lastname", name: "Last name" },
  { label_id: 80, label_name: "id_card", name: "ID card number" },
  {
    label_id: 81,
    label_name: "id_card_helper",
    name: "Please enter all 13 digits"
  },
  { label_id: 82, label_name: "day", name: "Day" },
  { label_id: 83, label_name: "month", name: "Month" },
  { label_id: 84, label_name: "birthday_year", name: "Year of birth" },
  { label_id: 85, label_name: "year", name: "Year" },
  { label_id: 86, label_name: "telephone", name: "Phone number" },
  { label_id: 87, label_name: "email", name: "Email" },
  { label_id: 88, label_name: "policy", name: "Privacy Policy" },
  { label_id: 89, label_name: "term", name: "Term and Condition" },
  { label_id: 90, label_name: "pdpa", name: "Manage personal information" }
];

export const previewBaseConfig = {
  brand_name: "Clarins",
  memberLiffUrl: "",
  member_url: "",
  custom_js: "",
  custom_font: "",
  custom_font_bold: "",
  font_size: "2",
  font_size_detail: [],
  isLoginLine: false,
  socialProvider: "preview",
  socialID: "preview-user",
  line_layout: "Compact",
  progress_display: 0,
  display_profile_complete: "1",
  customer_display_transaction_detail: "1",
  line_display_point_channel: "1",
  display_connect_channel: "1",
  line_display_member_level: "1",
  line_display_service_outstanding: "1",
  line_display_logout_button: "1",
  line_display_code_countdown: "1",
  line_display_right_request_link: "1",
  line_display_redeem_expire: "1",
  display_point_after_redeem: "1",
  display_upcomming_redeem: "1",
  display_reward_progress: "1",
  display_point_expired: "1",
  line_display_mission: "1",
  display_highlight_connect_channel: "1",
  display_email_login: "1",
  show_current_accumulated_amount: "1",
  show_balance_to_upgrade: "1",
  line_display_setting_button: "1",
  display_edit_profile: "1",
  display_telephone_country: "1",
  year_format: 2
};

export const previewThemeResponse = {
  result: {
    ...previewBaseConfig,
    is_custom_privacy_link: "0",
    is_center_point: "1",
    consent_url_link: "",
    is_right_request_url: "0",
    right_request_url: "",
    is_term_and_con_url: "0",
    term_and_con_url: "",
    themeBackGround: "",
    themeBackgroundPage: 1,
    themeDisableColor: "#e5e5e5",
    themeLightPrimaryColor: "#f6e7e9",
    themeLogoHomePage: "",
    themeLogoLine: "",
    themeLogoLoginPage: "",
    themePrimaryColor: "#b68a8f",
    themePrintLogo: "",
    themeSecondaryColor: "#222222",
    themeSecondaryColorLine: "#ffffff",
    themeSolidColor: "#b68a8f",
    themeTransactionCodeBanner: "",
    themeTransactionCodeEarn: "",
    themeTransactionCodeError: "",
    bar_color: "#ffffff",
    button_color: "#b68a8f",
    font_color: "#342d39",
    themeNavigationBarColor: "#b6b1b8",
    point_logo: "",
    profile_complete_description: "Preview profile completion"
  },
  themeLogoDomain: ""
};

const previewMarketPlace = {
  marketplace: [
    {
      id: 1,
      branchId: 1,
      salesChannelId: 1,
      marketplace: "Lazada",
      shopName: "LINE",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    },
    {
      id: 2,
      branchId: 2,
      salesChannelId: 2,
      marketplace: "Shopee",
      shopName: "Marketplace",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    },
    {
      id: 3,
      branchId: 3,
      salesChannelId: 3,
      marketplace: "TikTok",
      shopName: "",
      marketplaceUrl: "",
      status: false
    },
    {
      id: 4,
      branchId: 4,
      salesChannelId: 4,
      marketplace: "Store",
      shopName: "Banobagi Store",
      marketplaceUrl: "",
      status: false
    }
  ],
  connect_marketplace: [
    {
      id: 1,
      branchId: 1,
      salesChannelId: 1,
      marketplace: "Lazada",
      shopName: "LINE",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    },
    {
      id: 2,
      branchId: 2,
      salesChannelId: 2,
      marketplace: "Shopee",
      shopName: "Marketplace",
      marketplaceUrl:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
      status: true
    }
  ],
  disconnect_marketplace: [
    {
      sale_channel_id: 3,
      sale_channel_name: "TikTok",
      marketplace: [
        {
          branch_id: 3,
          branch_name: "TikTok Shop"
        }
      ]
    },
    {
      sale_channel_id: 4,
      sale_channel_name: "Store",
      marketplace: [
        {
          branch_id: 4,
          branch_name: "Banobagi Store"
        }
      ]
    }
  ]
};

const previewTransactions = [
  {
    transaction_id: 101,
    fan_type_name: "Lucky Fans",
    right_amount: 1,
    rights_summary: [{ fan_type_name: "Lucky fans", right_amount: 1 }],
    transaction_date: "2026-05-21T17:39:00",
    branch_name: "Lazada BBT Cosmetic",
    invoice_no: "02_ZEN0626000010",
    total_item: 2,
    total_spend: 6200,
    product_list: [
      { product_id: 1001, barcode: "BN0001" },
      { product_id: 1004, barcode: "BN0004" }
    ]
  },
  {
    transaction_id: 102,
    fan_type_name: "Super Fans",
    right_amount: 2,
    rights_summary: [
      { fan_type_name: "Super fans", right_amount: 2 },
      { fan_type_name: "Lucky fans", right_amount: 4 }
    ],
    transaction_date: "2026-05-21T17:39:00",
    branch_name: "Shopee BBT Cosmetics",
    invoice_no: "02_ZEN0626000011",
    total_item: 2,
    total_spend: 2100,
    product_list: [{ product_id: 1002, barcode: "BN0002" }]
  },
  {
    transaction_id: 103,
    fan_type_name: "Special Fans",
    right_amount: -1,
    rights_summary: [
      { fan_type_name: "Super fans", right_amount: -1 },
      { fan_type_name: "Lucky fans", right_amount: -4 }
    ],
    transaction_date: "2026-05-16T17:39:00",
    branch_name: "TikTok Shop BANOBAGI Thailand - Cosmetic",
    invoice_no: "02_ZEN0626000012",
    total_item: 0,
    total_spend: 0,
    product_list: []
  },
  {
    transaction_id: 104,
    fan_type_name: "Lucky Fans",
    right_amount: 1,
    transaction_date: "2026-05-20T14:22:00",
    branch_name: "Banobagi Store",
    invoice_no: "02_ZEN0626000013",
    total_item: 1,
    total_spend: 980,
    product_list: [{ product_id: 1003, barcode: "BN0003" }]
  },
  {
    transaction_id: 105,
    fan_type_name: "Special Fans",
    right_amount: 1,
    rights_summary: [
      { fan_type_name: "Special fans", right_amount: 1 },
      { fan_type_name: "Lucky fans", right_amount: 4 }
    ],
    transaction_date: "2026-05-22T11:30:00",
    branch_name: "Watsons Siam Paragon",
    invoice_no: "02_ZEN0626000014",
    total_item: 1,
    total_spend: 1990,
    product_list: [{ product_id: 1005, barcode: "BN0005" }]
  }
];

const previewTransactionDetails = {
  101: {
    transaction_details: [
      {
        product_id: 1001,
        product_name: "Banobagi Vita Genic Jelly Mask",
        quantity: 1,
        after_discount_price: 1200
      },
      {
        product_id: 1004,
        product_name: "Genic Jelly Mask",
        quantity: 2,
        after_discount_price: 5000
      }
    ],
    grand_total: 6200
  },
  102: {
    transaction_details: [
      {
        product_id: 1002,
        product_name: "Banobagi Milk Thistle Repair Cream",
        quantity: 2,
        after_discount_price: 2100
      }
    ],
    grand_total: 2100
  },
  103: {
    transaction_details: [],
    grand_total: 0
  },
  104: {
    transaction_details: [
      {
        product_id: 1003,
        product_name: "Banobagi Calming Care Moisturizer",
        quantity: 1,
        after_discount_price: 980
      }
    ],
    grand_total: 980
  },
  105: {
    transaction_details: [
      {
        product_id: 1005,
        product_name: "Banobagi Final Sleeping Mask",
        quantity: 1,
        after_discount_price: 1990
      }
    ],
    grand_total: 1990
  }
};

const previewReceiptCampaign = {
  id: 501,
  url_key: "preview-receipt",
  path_url_key: null,
  name: "Banobagi Receipt Campaign",
  description: "",
  receipt_scanner_type_id: 1,
  status: 1,
  banner:
    "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
  branch_group_id: 0,
  branch_list: null,
  product_group_id: 1,
  product_list: null,
  error_limit: 3,
  user_limit: 5,
  user_send: 0,
  number_of_receipt: 0,
  number_of_customer: 0,
  user_guid: previewProfile.user_guid,
  valid_from: "2026-01-01T00:00:00",
  valid_to: "2028-12-31T23:59:59",
  created_time: "2026-01-01T00:00:00"
};

const previewReceiptStatuses = [
  {
    receipt_scaner_status_language: [
      { user_receipt_scanner_status_id: 3, name: "Approved" }
    ]
  },
  {
    receipt_scaner_status_language: [
      { user_receipt_scanner_status_id: 1, name: "Pending review" }
    ]
  },
  {
    receipt_scaner_status_language: [
      { user_receipt_scanner_status_id: 4, name: "Incorrect receipt" }
    ]
  }
];

const previewReceiptHistory = [
  {
    id: 703,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    invoice_no: "02_ZEN0626000010",
    branch_name: "Watson Siam Paragon",
    receipt_time: "2026-05-21T17:39:00",
    status: 3,
    point: 250,
    error_detail: "",
    is_check: 1,
    receipt_scaner_status_language: [{ name: "Approved" }]
  },
  {
    id: 701,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    invoice_no: "",
    branch_name: "",
    receipt_time: "2026-05-20T17:39:00",
    status: 1,
    point: 0,
    error_detail: "",
    is_check: 0,
    receipt_scaner_status_language: [{ name: "Pending review" }]
  },
  {
    id: 702,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    invoice_no: "",
    branch_name: "",
    receipt_time: "2026-05-18T17:39:00",
    status: 4,
    point: 0,
    error_detail: "The receipt image is not clear.",
    is_check: 0,
    receipt_scaner_status_language: [{ name: "Incorrect receipt" }]
  },
  {
    id: 704,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    invoice_no: "",
    branch_name: "",
    receipt_time: "2026-05-19T17:39:00",
    status: 1,
    point: 0,
    error_detail: "",
    is_check: 0,
    receipt_scaner_status_language: [{ name: "Waiting for staff review" }]
  }
];

const previewNewsList = [
  {
    id: 1,
    name: "Preview News",
    short_description: "Mock content for LINE profile preview.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  },
  {
    id: 2,
    name: "New Promotion",
    short_description: "Promotion preview item from admin settings.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  },
  {
    id: 3,
    name: "Member Privilege",
    short_description: "Sample privilege card for iframe preview.",
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    is_video: 0
  }
];

const previewBannerList = [
  {
    id: 1,
    image_url:
      "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg",
    redirect_url: "",
    name: "Preview Banner"
  }
];

export function isPreviewMode() {
  return new URLSearchParams(window.location.search).get("preview") === "1";
}

export function getPreviewConfig() {
  const value = new URLSearchParams(window.location.search).get(
    "preview_config"
  );

  if (!value) return {};

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Invalid preview_config", error);
    return {};
  }
}

export function applyPreviewConfig(config, themeResponse) {
  const previewConfig = getPreviewConfig();

  Object.assign(config, previewConfig, {
    isLoginLine: false,
    socialProvider: "preview",
    socialID: "preview-user"
  });

  if (themeResponse?.result) {
    themeResponse.result = {
      ...themeResponse.result,
      ...previewConfig
    };
  }
}

export function createPreviewConfig() {
  return {
    ...previewBaseConfig,
    ...getPreviewConfig()
  };
}

export function createPreviewThemeResponse() {
  const previewConfig = getPreviewConfig();

  return {
    ...previewThemeResponse,
    result: {
      ...previewThemeResponse.result,
      ...previewConfig
    }
  };
}

export function seedPreviewStore(store) {
  store.commit("setShortProfile", previewProfile);
  store.commit("setCloneProfile", previewProfile);
  store.commit("setCompleteProfile", {
    detail: {
      profile: 80
    }
  });
  store.commit("setAuthen", true);
  store.commit("setIsMemberBypass", 1);
  store.commit("setIsUser", {
    status: 1,
    provider: {
      userId: "preview-user",
      displayName: "Preview Member",
      pictureUrl: ""
    }
  });
}

export function getPreviewResponse(config) {
  const url = config?.url || "";

  if (url.includes("/api/v1/user/GetUserProfile")) {
    return {
      result: 1,
      detail: previewProfile
    };
  }

  if (url.includes("/api/v1/setting/display_language/label/")) {
    return {
      result: 1,
      detail: {
        label: previewLabelValues,
        default_label: previewLabelValues.map(item => ({
          ...item,
          language_id: 1
        }))
      }
    };
  }

  if (url.includes("/api/v1/setting/display_language/customer_menu")) {
    return {
      result: 1,
      detail: [
        {
          id: 1,
          display: 1,
          name: "Rewards",
          menu_url: "/reward"
        },
        {
          id: 2,
          display: 1,
          name: "Purchase History",
          menu_url: "/transaction-summary"
        },
        {
          id: 3,
          display: 1,
          name: "Receipts",
          menu_url: "/receipt?urlKey=preview-receipt"
        }
      ]
    };
  }

  if (url.includes("/api/v1/setting/display_language")) {
    return {
      result: 1,
      detail: previewLabels
    };
  }

  if (url.includes("/api/v1/User/GetCompleteProfile")) {
    return {
      result: 1,
      detail: {
        profile: 80
      }
    };
  }

  if (url.includes("/api/v1/MonthlyPrivilege/list")) {
    return {
      result: 1,
      detail: {
        totalCount: previewNewsList.length,
        detail: previewNewsList
      }
    };
  }

  if (url.includes("/api/v1/banner/campaign_form")) {
    return {
      result: 1,
      detail: {
        totalCount: previewBannerList.length,
        detail: previewBannerList
      }
    };
  }

  if (url.includes("/api/v1/User/get/marketplace")) {
    return {
      result: 1,
      detail: previewMarketPlace
    };
  }

  if (url.includes("/api/v1/ReceiptScanner/get?urlKey=")) {
    return {
      result: 1,
      detail: previewReceiptCampaign
    };
  }

  if (url.includes("/api/v1/ReceiptScanner/GetUserReceiptScannerStatus")) {
    return {
      result: 1,
      detail: previewReceiptStatuses
    };
  }

  const receiptHistoryMatch = url.match(
    /\/api\/v1\/ReceiptScanner\/getReceiptHistory\/[^/]+\/(\d+)/
  );
  if (receiptHistoryMatch) {
    const statusId = Number(receiptHistoryMatch[1]);
    const receipts =
      statusId === 0
        ? previewReceiptHistory
        : previewReceiptHistory.filter(item => item.status === statusId);

    return {
      result: 1,
      detail: {
        data: receipts,
        sum_point: 250,
        point_expired: []
      }
    };
  }

  if (url.includes("/api/v1/user/UploadImage")) {
    return {
      result: 1,
      detail:
        "https://api-hourglass-admin-dev.dosetech.co/media/NewsImage/231026021009526.jpg"
    };
  }

  if (url.includes("/api/v1/ReceiptScanner/submit")) {
    return {
      result: 1,
      detail: {
        isMaxError: false,
        isMaxUpload: false,
        uploadedCount: 1
      }
    };
  }

  if (url.includes("/list_customer_transaction")) {
    return {
      result: 1,
      detail: {
        transaction_list: previewTransactions,
        allPage: 1,
        totalRecord: previewTransactions.length,
        total_right: 8
      }
    };
  }

  const transactionDetailMatch = url.match(
    /\/customer_transaction\/([^/?]+)/
  );
  if (transactionDetailMatch) {
    return {
      result: 1,
      detail: previewTransactionDetails[transactionDetailMatch[1]] || {
        transaction_details: [],
        grand_total: 0
      }
    };
  }

  if (url.includes("/api/v1/FriendGetFriend/get")) {
    return {
      result: 1,
      detail: []
    };
  }

  if (url.includes("/api/v1/setting/customlink/list")) {
    return {
      result: 1,
      detail: []
    };
  }

  if (url.includes("/api/v1/setting/navigation")) {
    return {
      result: 1,
      detail: [
        { id: 1, name: "Home", active: 1 },
        { id: 2, name: "Service", active: 1 },
        { id: 3, name: "QR", active: 1 },
        { id: 4, name: "Reward", active: 1 },
        { id: 5, name: "Profile", active: 1 }
      ]
    };
  }

  if (url.includes("/api/CustomObject/custom_object_register_page")) {
    return {
      result: 1,
      detail: []
    };
  }

  return null;
}
